/*
 *  I15HYDROACCUReducer.ts
 *
 *  Created by Sébastien Hecart on 2022-06-18 13:39:25 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15HYDROACCU_State } from '@batical/types/src'

const I15HYDROACCU: I15HYDROACCU_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_puissance: 0,
  in_duree_charge_bois: 2.0,
  in_puissance_chaudiere: 7.0,
  in_deperdition: 16.0,
  in_puissance_mini_chaudiere: 25.0,
  in_e_liberee: 15000.0,
  in_capacite_eau_chaudiere: 50.0,
  in_temp_retour: 12.0,
  in_temp_max_stockage: 20.0,
  res_volume_tampon: 0.0,
  res_volume_tampon_nominal: 0.0,
  mode: 'none',
  calcul_code: 'I15HYDROACCU'
}

export default I15HYDROACCU
